/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProxyChallengeOptions
 */
export interface ProxyChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof ProxyChallengeOptions
     */
    challenge_id?: string;
}

/**
 * Check if a given object implements the ProxyChallengeOptions interface.
 */
export function instanceOfProxyChallengeOptions(value: object): value is ProxyChallengeOptions {
    return true;
}

export function ProxyChallengeOptionsFromJSON(json: any): ProxyChallengeOptions {
    return ProxyChallengeOptionsFromJSONTyped(json, false);
}

export function ProxyChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyChallengeOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'] == null ? undefined : json['challenge_id'],
    };
}

export function ProxyChallengeOptionsToJSON(json: any): ProxyChallengeOptions {
    return ProxyChallengeOptionsToJSONTyped(json, false);
}

export function ProxyChallengeOptionsToJSONTyped(value?: ProxyChallengeOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
    };
}

